import { secureStorage } from '@mq/volt-amc-container';

const readDnaConfigByActiveProgram = () => {
  try {
    const activeProgram = secureStorage.getItem('selectedActiveProgram');
    const { short_name } = JSON.parse(activeProgram);
    const dnaConfigs = JSON.parse(secureStorage.getItem('dnaPrograms'));

    return dnaConfigs[short_name];
  } catch (error) {
    console.warn(`Unable to read active program from localStorage ${error}`);
  }
};

export default readDnaConfigByActiveProgram;
